// Admin → Artists list (paged table, filters, bulk actions).
const en = {
  "admin.users.allPlans": "All plans",
  "admin.users.approvePending": "Approve {n} pending",
  "admin.users.bulkApproved": "{n} artist(s) approved",
  "admin.users.bulkPartial": "{ok} approved, {fail} failed",
  "admin.users.exportCsv": "Export CSV",
  "admin.users.exported": "{n} rows exported",
  "admin.users.exportFailed": "Export failed",
  "admin.users.pageOf": "Page {page} of {pages} · {total} artists",
  "admin.users.plan": "Plan",
  "admin.users.planFilter": "Filter by plan",
  "admin.users.releasesCount": "{n} releases · {live} live",
  "admin.users.select": "Select",
  "admin.users.statusTabs": "Filter by status",
};
const tr = {
  "admin.users.allPlans": "Tüm planlar",
  "admin.users.approvePending": "{n} bekleyeni onayla",
  "admin.users.bulkApproved": "{n} sanatçı onaylandı",
  "admin.users.bulkPartial": "{ok} onaylandı, {fail} başarısız",
  "admin.users.exportCsv": "CSV dışa aktar",
  "admin.users.exported": "{n} satır dışa aktarıldı",
  "admin.users.exportFailed": "Dışa aktarma başarısız",
  "admin.users.pageOf": "Sayfa {page}/{pages} · {total} sanatçı",
  "admin.users.plan": "Plan",
  "admin.users.planFilter": "Plana göre filtrele",
  "admin.users.releasesCount": "{n} yayın · {live} yayında",
  "admin.users.select": "Seç",
  "admin.users.statusTabs": "Duruma göre filtrele",
};
const es = {
  "admin.users.allPlans": "Todos los planes",
  "admin.users.approvePending": "Aprobar {n} pendientes",
  "admin.users.bulkApproved": "{n} artista(s) aprobado(s)",
  "admin.users.bulkPartial": "{ok} aprobados, {fail} fallidos",
  "admin.users.exportCsv": "Exportar CSV",
  "admin.users.exported": "{n} filas exportadas",
  "admin.users.exportFailed": "Error al exportar",
  "admin.users.pageOf": "Página {page} de {pages} · {total} artistas",
  "admin.users.plan": "Plan",
  "admin.users.planFilter": "Filtrar por plan",
  "admin.users.releasesCount": "{n} lanzamientos · {live} publicados",
  "admin.users.select": "Seleccionar",
  "admin.users.statusTabs": "Filtrar por estado",
};
export default { en, tr, es };
